import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";

import storage from "redux-persist/lib/storage";
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";
import listenerMiddleware from "./listenerMiddleware";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import {PersistConfig} from "redux-persist/es/types";


import { userPreferenceReducer } from "../components/userPreference/userPreferenceSlice";
import { authenticationReducer } from "../components/authentication/authenticationSlice";
import {comuniSliceReducer} from "../components/anagrafiche/comuni/comuniSlice";
import { allegatiSliceReducer } from "../components/allegati/allegatiSlice";
import { utentiSliceReducer } from "components/authentication/utenti/utentiSlice";
import { ticketingSliceReducer } from "components/ticketing/ticketingSlice";
import { anagraficheSliceReducer } from "components/anagrafiche/anagraficheSlice";
import {previsioniSliceReducer} from "../components/main/pianificazione/previsioni/previsioniSlice";
import {budgetsSliceReducer} from "../components/main/pianificazione/budgets/budgetsSlice";
import {ordiniLavoroByPrevisioneSliceReducer} from "../components/main/pianificazione/previsioni/previsione/ordiniLavoro/ordiniLavoroByPrevisioneSlice";
import {ordiniLavoroSliceReducer} from "../components/main/produzione/ordiniLavoro/ordiniLavoroSlice";
import {
    assegnazioniGanttSliceReducer
} from "../components/main/produzione/ordiniLavoro/ordineLavoro/assegnazioni/gantt/assegnazioniGanttSlice";
// import {tasksSliceReducer} from "../components/tasks/tasksSlice";

const persistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
	key: "EvopRoot",
	storage,
	whitelist: [
		// "authentication",
		"userPreferenceState",
		"anagraficheState",
		// "comuniState",
	], // Elenco dei reducer persistenti
};

const rootReducer = combineReducers({
	userPreferenceState: userPreferenceReducer,
	authentication: authenticationReducer,
	comuniState: comuniSliceReducer,
	allegati: allegatiSliceReducer,
	utentiState: utentiSliceReducer,
    // tasksState: tasksSliceReducer,
	ticketsState: ticketingSliceReducer,
    anagraficheState: anagraficheSliceReducer,
    previsioniState: previsioniSliceReducer,
    ordiniLavoroByPrevisioneState: ordiniLavoroByPrevisioneSliceReducer,
    ordiniLavoroState: ordiniLavoroSliceReducer,
    budgetsState: budgetsSliceReducer,
    assegnazioniGanttState: assegnazioniGanttSliceReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    // middleware: [thunk],
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>(); // Export a hook that can be reused to resolve types

export default store;
export const persistor = persistStore(store);
